<template>
  <div>
    <Select  @on-change="change" v-model="sel" filterable placeholder="请选择分类" clearable>
      <Option v-for="item in list" :label="item.name" :value="item.id"></Option>
    </Select>
  </div>
</template>

<script>
export default {
  props:{
    value:{
      type:Array,
      default:[]
    },
    multiple:{
      type:Boolean,
      default: true
    }
  },
  data(){
    return{
      list:[],
      sel:[],
    }
  },
  methods:{
    change(){
      this.$emit('input',this.sel)
      this.$emit('on-change')
    }
  },
  created() {
    let that = this;
    this.$axios.get('/api/ziliao/ziliaoFenlei/getJsonList').then(function(rs){
      that.list = rs.data;
    });
  }

}
</script>



// WEBPACK FOOTER //
// src/components/ziliao/common/FenleiSelect.vue